{
  "manual": "Manual ({number})",
  "automatic": "Automatic",
  "payment_methods": {
    "payment_by_invoice": "Invoice",
    "payment_on_account": "On Account",
    "upfront_payment": "Upfront",
    "quote": "Quote"
  }
}
